export default {
  langName: "Deutsch",
  common: {
    company: "An Eagle Inc company",
    privacy: "Datenschutz",
    terms: "Nutzungsbedingungen",
    support: "Support",
  },
  nav: {
    group: "Eagle Eyes Group",
    realEstate: "Real Estate",
    itManagement: "IT Management",
    digitalServices: "Digital Services",
    backToGroup: "Eagle Eyes Group",
    property: "Property",
    investment: "Investment",
  },
  form: {
    name: "Vollständiger Name",
    email: "E-Mail-Adresse",
    sending: "Wird gesendet…",
    sent: "Danke — Ihre Angaben sind eingegangen. Wir melden uns in Kürze.",
    error: "Etwas ist schiefgegangen. Bitte versuchen Sie es erneut oder schreiben Sie uns direkt.",
  },
  gateway: {
    hero1: "EAGLE",
    hero2: "EYES",
    hero3: "GROUP",
    chapters: [
      { num: "01", name: "Real Estate", sub: "Property · Investment — Tirana", desc: "Mietwohnungen, die mit Sorgfalt betreut werden, und ein überprüfbarer, disziplinierter Ansatz für Wohnimmobilien-Investments.", cta: "Zu Real Estate" },
      { num: "02", name: "IT Management", sub: "Beratung & Managed Services", desc: "Senior-IT-Beratung für Cloud, Identität, Sicherheit und DevOps — präzise definiert, persönlich geliefert, langfristig betreut.", cta: "Zu IT Management" },
      { num: "03", name: "Digital Services", sub: "Produkte, die wir bauen & betreiben", desc: "Ein wachsendes Portfolio live geschalteter Web- und Mobilprodukte in Social Commerce, Marketing und Buchung — im eigenen Haus entwickelt und betrieben.", cta: "Zu Digital Services" },
    ],
    footerBrand: "Eagle Eyes Group",
  },
  re: {
    forClients: "Für Kunden",
    propertyH: "Property",
    propertyP: "Mietwohnungen im Zentrum von Tirana, mit Sorgfalt gefunden und betreut. Für Menschen, die ein Zuhause suchen, keine Transaktion.",
    propertyCta: "Zu Eagle Eyes Property",
    forInvestors: "Für Investoren",
    investmentH: "Investment",
    investmentP: "Ein überprüfbarer, disziplinierter Ansatz für Wohnimmobilien in Tirana. Für alle, die genau sehen wollen, was sie unterstützen.",
    investmentCta: "Zu Eagle Eyes Investment",
  },
  property: {
    kicker: "Eagle Eyes Property",
    h1: "Ein Zuhause in Tirana, von Anfang an betreut.",
    intro: "Wir finden, bereiten vor und verwalten Mietwohnungen im Zentrum von Tirana — für Mieter, die ein ordentlich geführtes Zuhause wollen, nicht nur ein Inserat.",
    cta: "Auf die Warteliste",
    navWhat: "Was wir machen",
    navHow: "So funktioniert es",
    navJoin: "Auf die Liste",
    whatTitle: "Was Eagle Eyes Property macht",
    whatMeta: "Onboarding läuft · Listings folgen",
    what: [
      { label: "Auswahl", title: "Kuratierte Wohnungen", text: "Jede Wohnung wird in zentralen Vierteln Tiranas ausgewählt und geprüft — kein Durchsuchen von Inseraten, die vor Ort nicht standhalten." },
      { label: "Verwaltung", title: "Ein Ansprechpartner", text: "Instandhaltung, Papierkram und Fragen laufen über ein Team, nicht über einen schwer erreichbaren Vermieter." },
      { label: "Transparenz", title: "Klare Konditionen, von vornherein", text: "Preise, Verträge und Kautionen werden verständlich erklärt, bevor Sie sich entscheiden — keine Überraschungen nach dem Einzug." },
    ],
    howTitle: "So funktioniert es",
    howMeta: "Drei Schritte",
    steps: [
      { title: "Sagen Sie uns, was Sie suchen", text: "Budget, Viertel, Größe, Einzugsdatum — die Grundlagen, die wirklich eingrenzen." },
      { title: "Wir matchen Sie mit freien Wohnungen", text: "Sie hören von uns, sobald passende Wohnungen verfügbar sind — keine Flut unpassender Optionen." },
      { title: "Einziehen, mit Betreuung danach", text: "Unterschrieben, eingezogen, betreut — Eagle Eyes bleibt Ihr Ansprechpartner, solange Sie bei uns mieten." },
    ],
    waitTitle: "Sehen Sie die Wohnungen zuerst",
    waitText: "Eagle Eyes Property nimmt seine ersten Wohnungen im Zentrum von Tirana in Betrieb. Hinterlassen Sie Ihre Daten und wir melden uns, sobald die Listings starten.",
    neighbourhood: "Bevorzugtes Viertel (optional)",
    waitButton: "Auf die Warteliste",
    waitNote: "Kein Spam — nur eine Nachricht, wenn Wohnungen verfügbar werden.",
    footerBrand: "Eagle Eyes Property",
  },
  investment: {
    kicker: "Eagle Eyes Investment",
    h1: "Wohnimmobilien in Tirana, gebaut zum Nachprüfen.",
    intro: "Eagle Eyes kauft und vermietet Wohnungen im Zentrum von Tirana über eine strukturierte albanische Holding — so geführt, dass jede Aussage überprüft werden kann, statt auf Vertrauen beruhen zu müssen.",
    cta: "Informationspaket anfordern",
    navThesis: "Der Aufbau",
    navTrack: "Track Record",
    navContact: "Kontakt",
    thesisTitle: "Wie Eagle Eyes aufgebaut ist",
    thesisP1: "Wir erwerben Wohnungen in zentralen Vierteln Tiranas, vermieten sie über Eagle Eyes Property an geprüfte Mieter und halten sie in einer eigenen Gesellschaftsstruktur — Eigentum, Verwaltung und Berichtswesen getrennt, damit jeder Bereich einzeln geprüft werden kann.",
    thesisP2: "Ziel ist ein Portfolio, das bewusst wächst: weniger Akquisitionen, jede so dokumentiert, dass ein Investor unsere Begründung rekonstruieren kann, ohne uns beim Wort nehmen zu müssen.",
    specs: [
      { k: "Eigentum", v: "Albanische Holding / SPV-Struktur" },
      { k: "Betrieb", v: "Verwaltet über Eagle Eyes Property" },
      { k: "Fokus", v: "Wohnungen im Zentrum von Tirana" },
      { k: "Berichtswesen", v: "Dokumentation auf Anfrage" },
    ],
    trackTitle: "Track Record",
    trackMeta: "Erste Akquisitionen laufen",
    trackBoxTitle: "Ergebnisse je Objekt — demnächst",
    trackBoxText: "Sobald Wohnungen erworben, vermietet und (wo zutreffend) veräußert sind, werden sie hier mit den Zahlen dahinter gelistet — Kaufpreis, durchgeführte Arbeiten, Auslastung und Rendite.",
    trackBoxNote: "Den aktuellen Stand vor Veröffentlichung? Fragen Sie unten.",
    verifyTitle: "Was verifizierte Investoren einsehen können",
    verify: [
      { label: "Entität", title: "Gesellschaftsstruktur", text: "Registrierungsunterlagen der Holding und SPV und wie das Eigentum jeder Wohnung darunter liegt." },
      { label: "Assets", title: "Details je Objekt", text: "Lage, Zustand, Kaufkonditionen und Mietstatus jeder gehaltenen oder angebotenen Wohnung." },
      { label: "Finanzen", title: "Zugrunde liegende Zahlen", text: "Kosten, Finanzierungskonditionen und Mieteinnahmen des Portfolios — direkt geteilt, nicht wegzusammengefasst." },
      { label: "Menschen", title: "Wer dahinter steht", text: "Hintergrund zu den Betreibern von Eagle Eyes und wie sich Property- und Investment-Seite zueinander verhalten." },
    ],
    contactTitle: "Fragen Sie nach den Details",
    contactText: "Sagen Sie uns, wer Sie sind und was Sie verifiziert sehen möchten. Wir melden uns direkt mit den relevanten Unterlagen.",
    roleLabel: "Ich melde mich als…",
    roles: ["Ein potenzieller Investor", "Ein bestehender Investor", "Sonstiges / Berater"],
    verifyField: "Was möchten Sie verifizieren? (optional)",
    contactButton: "Informationen anfordern",
    contactNote: "Unterlagen werden direkt mit namentlich bekannten Personen geteilt, nicht öffentlich veröffentlicht.",
    footerBrand: "Eagle Eyes Investment",
  },
  it: {
    kicker: "IT Management",
    h1a: "Eagle Eyes",
    h1b: "IT Management",
    hero: "End-to-End-IT-Beratung, maßgeschneidert auf Ihre Anforderungen — von gezielten Einzellösungen und umfassenden Strategien bis hin zu langfristigem Portfoliomanagement und laufender Wartung",
    heroCta: "Gespräch beginnen",
    navProcess: "So arbeiten wir",
    navExpertise: "Expertise",
    navEngagements: "Mandate",
    profileTitle: "Profil",
    profile: "Eagle Eyes IT Management ist eine Management- und Beratungspraxis für Kunden auf der ganzen Welt. Unsere Berater sind vom ersten Gespräch bis zur Übergabe direkt beteiligt — Endpoint, Identity, Device Management, Security und Cloud-Hosting auf Azure und Microsoft 365 — und bleiben über die gesamte Vertragslaufzeit für das Portfolio verantwortlich.",
    processTitle: "So arbeiten wir",
    process: [
      { num: "01", title: "Scope first", text: "Jedes Mandat beginnt mit Ihrer Anfrage, Folgegesprächen und einem schriftlichen Scope: Deliverables, Abnahmekriterien, nichts Vages." },
      { num: "02", title: "Discovery", text: "Eine detaillierte Untersuchung zu vereinbarten Beratungsstunden, im Voraus abgerechnet, mit einem vollständig kalkulierten Angebot am Ende." },
      { num: "03", title: "Contracting", text: "Einzelne Leistungen werden im Voraus abgerechnet. Laufende Arbeit wird auf Ihre Organisation zugeschnitten. Portfoliomanagement und Wartung auf Jahresverträgen mit monatlicher Abrechnung. Kombinationen sind verhandelbar." },
    ],
    expertiseTitle: "Expertise",
    expertise: [
      { title: "Modern Workplace", items: "Windows 11 · Intune · Autopilot" },
      { title: "Microsoft 365", items: "Exchange · SharePoint · Teams · Migrationen" },
      { title: "Security", items: "Defender · Hardening · Secrets · Patching" },
      { title: "Service Management", items: "Jira · JSM · Confluence · Prozessdesign" },
      { title: "Identity & Access", items: "Entra ID · Conditional Access · MFA · SSO" },
      { title: "Azure & Hosting", items: "IaaS / PaaS · Netzwerk · Domains · SSL" },
      { title: "DevOps & CI/CD", items: "Azure DevOps · Bitbucket · Pipelines" },
      { title: "IT-Management", items: "Service Design · Anbieter · Budgets" },
    ],
    engagementsTitle: "Ausgewählte Langzeitmandate",
    engagements: [
      { client: "Multinationaler Anbieter von Sprachsoftware", role: "IT Business Consultancy & Global DevOps Management", text: "Gründung der neuesten nationalen Niederlassung und Entwurf der globalen IT-Architektur des Konzerns. Dieses Mandat umfasste die Skalierung des lokalen Betriebs von 5 auf 60 Fachkräfte innerhalb von 18 Monaten — bei gleichzeitigem Aufbau und der Leitung der funktionsübergreifenden DevOps- und IT-Management-Teams, die die globale Büroinfrastruktur tragen." },
      { client: "Weltweite Autorität für Software-Engineering", role: "IT Cloud & DevOps Consultancy", text: "Strukturierung und Straffung der Unternehmens-IT-Infrastruktur für einen weltweit anerkannten Marktführer in der Softwareentwicklung. Dieses Mandat umfasste den Aufbau eines leistungsstarken DevOps-Ökosystems von Grund auf sowie das Engineering einer hybriden Rechenzentrumsinfrastruktur für mehr als 500 interne Anwender." },
      { client: "Landesweiter Enterprise-Dienstleister", role: "IT Cloud Consultancy & VoIP-Architektur", text: "Eingebettete, interne technische Beratung für Tier-One-B2B-Kunden und Serviceprovider. Der Kernfokus lag auf dem Entwurf und der Bereitstellung hochskalierbarer VoIP-Architekturen und Cloud-Lösungen auf Enterprise-Niveau." },
    ],
    contactTitle: "Gespräch beginnen",
    contactText: "Erzählen Sie uns von Ihrer Umgebung und Ihren Zielen. Wir antworten persönlich — in der Regel innerhalb eines Werktags.",
    companyField: "Unternehmen (optional)",
    messageField: "Wie können wir helfen?",
    contactButton: "Anfrage senden",
    contactBlockTitle: "Kontakt",
    servicesTitle: "Services & Skills",
    productsTitle: "Produkte & Marken",
    portfolioTitle: "Portfoliomanagement",
    services: ["Moderner Arbeitsplatz", "Microsoft 365", "Sicherheit", "Service Management", "Identity & Access", "Azure & Hosting", "DevOps & CI/CD", "IT-Management"],
    products: ["Microsoft 365", "Azure", "Entra ID", "Intune", "PowerShell", "Azure DevOps", "Bitbucket", "Postman", "Jira", "Jira Service Management", "Confluence", "Twilio", "Agora"],
    portfolio: ["Service Design", "Anbietermanagement", "Budgetverantwortung", "Wartung & Support", "Jahresverträge", "Monatliche Abrechnung"],
    footerBrand: "Eagle Eyes IT Management",
  },
  digital: {
    kicker: "Eagle Eyes Digital Services",
    h1: "Produkte, die wir bauen, betreiben und wachsen lassen.",
    intro: "Digital Services ist das Produktstudio von Eagle Eyes: Wir entwerfen, launchen und betreiben eigene Web- und Mobilprodukte in Social Commerce, Marketing und Buchung.",
    navPortfolio: "Das Portfolio",
    navDeals: "Deals & Marketing",
    navContact: "Kontakt",
    appsTitle: "Das Portfolio",
    live: "Live",
    soon: "Demnächst",
    capsTitle: "Was wir bauen",
    caps: [
      { title: "Social Commerce", text: "Verwandelt Zielgruppen in Kunden — mit kaufbaren Picks und Deals." },
      { title: "Kampagnen & Deals", text: "Zeitlich begrenzte Aktionen, gebaut zum Teilen und für schnelle Konversion." },
      { title: "Buchung & Planung", text: "Termine, Verfügbarkeit und Erinnerungen ohne Reibung." },
      { title: "Analytics & Insights", text: "Jedes Produkt gemessen — vom ersten Klick bis zum Stammkunden." },
    ],
    studioTitle: "Ein hauseigenes Produktstudio",
    studioText: "Digital Services entwirft, baut und betreibt die eigenen Produkte von Eagle Eyes von Anfang bis Ende — von der ersten Skizze bis zu Infrastruktur, Support und Wachstum. Keine Kundenarbeit, keine Agenturen: eigene Produkte, eigener Standard.",
    statProducts: "Produkte",
    statLive: "Live",
    statLaunching: "Im Launch",
    apps: [
      { name: "Socialdeal", tag: "Deals & Marketing", status: "live", desc: "Socialdeal bietet lokalen Unternehmen einen schnellen Weg, zeitlich begrenzte Deals und Kampagnen zu veröffentlichen — gebaut für soziales Teilen und direkte Konversion.", url: "https://www.socialdeal.al/", cta: "Socialdeal besuchen", features: ["Zeitlich begrenzte Deals veröffentlichen", "Gebaut für soziales Teilen", "Direkte Konversionsflows"] },
      { name: "BookItNow", tag: "Buchungsplattform", status: "soon", desc: "BookItNow ist unser neuestes Produkt: einfache, schnelle Online-Buchung für Dienstleistungsbetriebe — Termine, Verfügbarkeit und Erinnerungen an einem Ort.", url: "", cta: "Demnächst", features: ["Online-Terminbuchung", "Live-Verfügbarkeit", "Automatische Erinnerungen"] },
      { name: "InContact", tag: "SIP- & PBX-Telefonie", status: "soon", desc: "InContact ist unser SIP- & PBX-System: Cloud-Telefonie mit Geschäftsnummern, Anruf-Routing und Warteschlangen — online verwaltet, ganz ohne Hardware vor Ort.", url: "", cta: "Demnächst", features: ["SIP-Trunks & Hosted-PBX", "Anruf-Routing & Rufgruppen", "Nummern & Voicemail online"] },
    ],
    contactTitle: "Arbeiten Sie mit uns",
    contactText: "Interesse an einem Produkt, einer Partnerschaft oder einem Pilotprojekt? Hinterlassen Sie eine Nachricht.",
    messageField: "Ihre Nachricht",
    contactButton: "Nachricht senden",
    footerBrand: "Eagle Eyes Digital Services",
  },
  inc: {
    hero1: "EAGLE",
    hero2: "INC",
    intro: "Eine Holding, zwei Gruppen — wo Service und Entwicklung zusammenkommen.",
    eyesBtn: "Eagle Eyes Group",
    eyesSub: "Real Estate · IT Management · Digital Services",
    eyesCta: "Zu Eagle Eyes Group",
    commerceBtn: "Eagle Commerce Group",
    commerceSub: "Socialdeal · BookItNow · InContact",
    commerceCta: "Zu Eagle Commerce Group",
    footerBrand: "Eagle Inc",
    footerLegal: "Eagle Inc Sh.P.K.",
    tagline: "Holdinggesellschaft",
  },
  commerce: {
    hero1: "EAGLE",
    hero2: "COMMERCE",
    hero3: "GROUP",
    intro: "Eagle Commerce Group entwirft, lanciert und betreibt eigene E-Commerce-Produkte — von lokalen Angeboten über Buchungen bis hin zum Kundenkontakt.",
    live: "Live",
    soon: "Demnächst",
    visit: "Besuchen",
    explore: "Entdecken",
    products: [
      { name: "Socialdeal", tag: "Deals & Marketing", status: "live", desc: "Lokale Deals und Marketingkampagnen — schnell veröffentlicht, social geteilt, direkt konvertiert.", url: "https://www.socialdeal.al/", brand: "Eagle Commerce Socialdeal", h1: "Lokale Deals, gemacht zum Teilen.", story: "Socialdeal gibt lokalen Unternehmen einen schnellen, sozialen Weg, zeitlich begrenzte Deals und Kampagnen zu veröffentlichen — gebaut zum Teilen, abgestimmt auf direkte Konversion.", points: ["Zeitlich begrenzte Deals veröffentlichen", "Für soziales Teilen gebaut", "Direkte Conversion-Flows"] },
      { name: "BookItNow", tag: "Buchungsplattform", status: "soon", desc: "Einfache, schnelle Online-Buchung für Dienstleister — Termine, Verfügbarkeit und Erinnerungen an einem Ort.", url: "", brand: "Eagle Commerce BookItNow", h1: "Buchen, ganz ohne Reibung.", story: "BookItNow ermöglicht Dienstleistern, in wenigen Minuten online Termine anzunehmen — mit Live-Verfügbarkeit, automatischen Erinnerungen und einem Buchungsablauf, den Kunden wirklich abschließen.", points: ["Online-Terminbuchung", "Live-Verfügbarkeit", "Automatische Erinnerungen"] },
      { name: "InContact", tag: "SIP- & PBX-Telefonie", status: "soon", desc: "Cloud-Telefonie für Unternehmen: SIP-Trunks, Hosted-PBX und jede Nummer an einem Ort.", url: "", brand: "Eagle Commerce InContact", h1: "Geschäftstelefonie, ganz ohne Hardware.", story: "InContact ist eine vollständige SIP- & PBX-Plattform in der Cloud: Geschäftsnummern, Anruf-Routing, Warteschlangen und Voicemail — online verwaltet, ohne Hardware vor Ort.", points: ["SIP-Trunks & Hosted-PBX", "Anruf-Routing & Warteschlangen", "Nummern online verwaltet"] },
    ],
    footerBrand: "Eagle Commerce Group",
  },
};
